// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2ReNY","content":"LoadingAlert_content__32HjQ"};